export default {
    path: 'beisen',
    name: 'beisen',
    component: () => import('@/pages/beisen/IndexList'),
    meta: { title: '北森报表' }
}
